import {
    cleanCommonParams,
    mapAttachmentParams,
} from './common';

const mapUserProductsAuthorityImportsParams = (
    isCreate,
    {
        attachment,
        ...params
    },
) => {
    return new Promise((resolve) => {
        resolve({
            user_products_authority_import: {
                ...cleanCommonParams(params),
                ...mapAttachmentParams(isCreate, attachment),
            },
        });
    });
};

export { mapUserProductsAuthorityImportsParams };
